import { environmentVars } from 'constants/services';

export const product = {
  productName: environmentVars.BB_BRANDING ? 'Bluebeam Cloud' : 'Project Rover',
};

export const buttons = {
  accept: 'Accept',
  addDrawings: 'Add Drawings',
  back: 'Back',
  bbId: 'Get BBID',
  betaAccess: 'Request Beta Access Code',
  browseFiles: 'Browse Files',
  cancel: 'Cancel',
  confirmProject: 'Confirm Project',
  confirmSelection: 'Confirm Selection',
  confirmUpload: 'Confirm Upload',
  close: 'Close',
  closeProject: 'Close Project',
  continue: 'Continue',
  contact: 'Contact Us',
  create: 'Create',
  createGroup: 'Create Group',
  decline: 'Decline',
  delete: 'Delete',
  deleteProject: 'Delete Project',
  disconnect: 'Disconnect',
  discussion: 'Discussion',
  dismiss: 'Dismiss',
  export: 'Export',
  forward: 'Forward',
  getStarted: `Get Started with ${product.productName}`,
  importDrawings: 'Import Drawings',
  insertFiles: 'Insert Files',
  invite: 'Invite',
  inviteUser: 'Invite User',
  next: 'Next',
  openApp: 'Open in App',
  openProject: 'Open Project',
  previous: 'Previous',
  purchase: 'Purchase',
  reconnect: 'Reconnect',
  refreshSession: 'Refresh Session',
  remove: 'Remove',
  reopen: 'Reopen',
  reply: 'Reply',
  requestAccess: 'Request Access Code',
  requestCode: 'Request a Code',
  respond: 'Respond',
  rfiAttachDiscussion: 'Attach to Official Response',
  rfiResponse: 'Create Official Response',
  save: 'Save',
  saveChanges: 'Save Changes',
  selectMore: 'Select More',
  send: 'Send',
  sendRequest: 'Send Request',
  share: 'Share with Project',
  signIn: 'Sign In',
  signInToGetStarted: 'Sign In to Get Started',
  signOut: 'Sign Out',
  signUp: 'Sign Up',
  start: 'Start',
  submit: 'Submit',
  subscribe: 'Subscribe',
  sync: 'Sync',
  uploadFiles: 'Upload Files',
  watchDemo: 'Watch the Demo',
};

export const emptySearchResults = {
  search: 'No Results',
  searchKeywords: 'Try searching other keywords.',
  searchMsg:
    'We couldn’t find any items matching your search. Try searching other keywords.',
  filter: 'No Matching Items',
  filterMsg: 'To see matching items, adjust your filters.',
  filterBtn: 'Remove All Filters',
};

export const formLabels = {
  assignee: 'Assignee',
  attachments: 'Attachments',
  billingAddress: 'Billing Address',
  cardDetails: 'Card Details',
  city: 'City',
  company: 'Company',
  distroList: 'Distribution List',
  duedate: 'Due Date',
  email: 'Email',
  forwardTo: 'Forward to',
  impact: 'Impact',
  jobTitle: 'Job Title',
  message: 'Message',
  multipleGroups: 'Multiple Groups',
  name: 'Name',
  nameOnCard: 'Name on Card',
  officialResponse: 'Official Response',
  paymentDetails: 'Payment Details',
  question: 'Question',
  project: 'Tell us about your project',
  projectAddress: 'Project Address',
  projectCode: 'Project Code',
  projectDetails: 'Project Details',
  projectName: 'Project Name',
  subject: 'Subject',
  state: 'State',
  streetAddress: 'Street Address',
  zipcode: 'Zip Code',
  to: 'To',
};

export const contactUsModalFields = {
  title: 'Contact Us',
  subject: 'Contact Us',
  description: 'Send us a message and we’ll get back to you!',
  messageTitle: 'Tell us about your project',
  submitButtonText: buttons.submit,
  submittedHeader: 'Message Sent!',
  submittedBody: `Thank you for your interest in ${product.productName}. We will be in touch soon!`,
};

export const requestAccessModalFields = {
  title: 'Request Beta Access Code',
  subject: 'Request Beta Access Code',
  description: 'Review and confirm your request below.',
  messageTitle: 'Tell us about your project',
  submitButtonText: buttons.submit,
  submittedHeader: 'Request Sent!',
  submittedBody: 'We are reviewing your request. We will be in touch soon!',
};

export const subscribePaymentModalFields = {
  title: 'Subscribe',
  cancelButtonText: buttons.cancel,
  closeButtonText: buttons.close,
  submitButtonText: buttons.save,
  successHeader: 'Payment Successful',
  successMessage:
    'We will send confirmation to the email address associated with your Bluebeam ID.',
};

export const createdProjectModalFields = {
  title: 'Create a New Project',
  header: 'Project Created',
  closeButtonText: buttons.close,
  submitButtonText: buttons.openProject,
};

export const approvedSubmittalsTab = {
  noApprovedSubmittals: 'No Approved Submittals',
  noApprovedSubsMsg:
    'Once Submittals begin to be approved, they will appear here.',
};

export const settingsPageNavText = {
  PROJECT: 'Project Settings',
  INTEGRATIONS: 'Integrations',
};

export const fileBrowser = {
  filter: {
    noResults: {
      title: 'No Results',
      body: 'Try searching other keywords.',
    },
  },
  bar: {
    recommendSync: {
      title: 'Sync Recommended',
      problem: (
        providerName: string
      ): string => `We detect that some files have been changed from your
      ${providerName} account since it was last synced to ${product.productName},`,
      solution: 'Press the Sync button to begin the update.',
    },
  },
};

export const RFIForm = {
  attachments: {
    upload: 'Upload Files',
    insert: 'Insert Files',
  },
};

export const insertFilesModal = {
  from: {
    drawings: `From ${
      environmentVars.BB_BRANDING ? 'Bluebeam Beyond' : 'Rover'
    } Drawings`,
    integrations: 'From Integrations',
  },
  drawings: {
    title: 'Drawings',
  },
  integrations: {
    emptyState: {
      title: 'None Yet',
      body: 'Connect an account from the Integrations tab in your Settings.',
    },
  },
  itemsCount: 'Selected Items',
  cancel: 'Cancel',
  submit: 'Insert Files',
};

export const projectDetails = {
  buttons: {
    cancel: 'Cancel',
    save: 'Save Changes',
    editPayment: 'Edit Payment Method',
    editProject: 'Edit Details',
  },
  payment: {
    title: 'Payment Details',
  },
  project: {
    title: 'Project Details',
  },
};

export const monthlyPrice = '$300';

export const toastText = {
  drawingsDeleteError: {
    title: 'Drawings Error',
    message: 'We are unable to delete selected drawings.',
  },
  drawingsPublished: {
    title: 'Drawings Published',
    message: 'Your drawings have been published',
  },
  drawingsReadyForReview: {
    title: 'Drawings Ready for Review',
    message: 'Your drawings have been uploaded and are ready for review.',
  },
  drawingsUploaded: {
    title: 'Drawings Upload Complete',
    message:
      'We are currently processing your files. This may take a few minutes.',
  },
  drawingsUploadError: {
    title: 'Drawings Error',
    message: 'We are unable to upload one or more of your drawings.',
  },
  fileUploadError: {
    title: 'Upload Error',
    message: 'We are unable to upload one or more of your files.',
  },
  imageDownloadError: {
    title: 'Unknown Error',
    message: 'We are unable to download this image.',
  },
  paymentError: {
    title: 'Payment Error',
    message: 'We are unable to process your payment details. Please try again.',
  },
  paymentGenericSystemError: {
    title: 'There was an error processing your payment',
    message: 'Please try again later.',
  },
  projectCreateError: {
    title: 'Project Error',
    message: 'We are unable to create this project.',
  },
  projectDelete: {
    title: 'Project Deleted',
    message: 'We have successfully deleted your project and all of its data.',
  },
  projectDeleteError: {
    title: 'Project Error',
    message: 'We are unable to delete this project.',
  },
  punchCreateError: {
    title: 'Punch Error',
    message: 'We are unable to create this punch item.',
  },
  punchGetError: {
    title: 'Punch Error',
    message: 'We are unable to find this punch item.',
  },
  removeUsersError: {
    title: 'Admin Error',
    message: 'We are unable to remove users from this project.',
  },
  rfiCreateError: {
    title: 'RFI Error',
    message: 'We are unable to create this RFI.',
  },
  rfiDownloadLogError: {
    title: 'RFI Error',
    message: 'We are unable to download the RFI Log.',
  },
  rfiDraftDeleted: {
    title: 'RFI Deleted',
    message: 'Your RFI draft has been deleted.',
  },
  rfiDraftDeleteError: {
    title: 'RFI Error',
    message: 'We are unable to delete this RFI draft.',
  },
  rfiDraftSaveError: {
    title: 'RFI Error',
    message: 'We are unable to save this RFI draft.',
  },
  rfiDraftPublishError: {
    title: 'RFI Error',
    message: 'We are unable to publish this RFI.',
  },
  rfiForwardError: {
    title: 'RFI Error',
    message: 'We are unable to forward thiss RFI.',
  },
  rfiRespondError: {
    title: 'RFI Error',
    message: 'We are unable to send your response to this RFI.',
  },
  rfiAttachDiscussionError: {
    title: 'RFI Error',
    message: 'We are unable to attach your discussion to this RFI.',
  },
  rfiReopenError: {
    title: 'RFI Error',
    message: 'We are unable to reopen this RFI.',
  },
};

export const drawingSelectionNoticeModal = {
  drawingViewNotSupported:
    'Viewing your drawings is not yet supported on your device.',
  ipad: {
    downloadAppHeader:
      'To view your drawings, download the app from the App Store.',
    downloadAppFooter: `Alternatively, you can use ${product.productName} from a laptop or desktop computer.`,
  },
  tablets: {
    header: `To view your drawings, we recommend that you use ${product.productName} from a laptop or desktop computer.`,
    footer:
      'If you have an Apple mobile device, you may also download the app from the App Store for an optimal mobile experience.',
  },
};

export const tooltips = {
  groups: {
    title: 'Grouping Users',
    content:
      'Selecting a group for a user will allow you to more quickly assign a group of users to a Punch.',
  },
};
